import React, { useState } from "react";

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: "user", content: input };
    setMessages((prev) => [...prev, userMessage]);
    setLoading(true);

    try {
      // Replace with your local server URL
      const response = await fetch("http://localhost:8080/v1/chat/completions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "your-model-name", // usually gguf filename without .gguf
          messages: [{ role: "user", content: input }],
          stream: false
        }),
      });

      const data = await response.json();

      const botMessage = {
        role: "assistant",
        content: data.choices?.[0]?.message?.content || "No response",
      };

      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "⚠️ Server Error or Model not running" },
      ]);
    }

    setLoading(false);
    setInput("");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Local GGUF Chatbot</h1>

      <div style={styles.chatBox}>
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              ...styles.message,
              alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
              background: msg.role === "user" ? "#d1e7ff" : "#e6e6e6",
            }}
          >
            <strong>{msg.role === "user" ? "You" : "Bot"}:</strong>{" "}
            {msg.content}
          </div>
        ))}

        {loading && <div style={styles.loading}>Typing...</div>}
      </div>

      <div style={styles.inputContainer}>
        <input
          style={styles.input}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
        />

        <button style={styles.button} onClick={sendMessage} disabled={loading}>
          Send
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Arial",
    width: "100%",
    maxWidth: 600,
    margin: "0 auto",
    paddingTop: 40,
  },
  heading: {
    textAlign: "center",
  },
  chatBox: {
    border: "1px solid #ccc",
    borderRadius: 8,
    padding: 16,
    height: "70vh",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    background: "#fafafa",
  },
  message: {
    padding: 10,
    borderRadius: 8,
    maxWidth: "80%",
    lineHeight: 1.4,
  },
  loading: {
    fontStyle: "italic",
    color: "#888",
  },
  inputContainer: {
    display: "flex",
    gap: 10,
    marginTop: 20,
  },
  input: {
    flex: 1,
    padding: 10,
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 16,
  },
  button: {
    padding: "10px 20px",
    fontSize: 16,
    border: "none",
    borderRadius: 6,
    background: "#007bff",
    color: "white",
    cursor: "pointer",
  },
};

export default App;
